/*!
 * @copyright	Copyright (C) 2016 Piotr Konieczny. All rights reserved.
 * @license		GNU General Public License version 2 or later; see LICENSE.txt
 */

/**
 * Content component UI decorator
 */
window.WgTemplate.PkgContent = (function() {

    'use strict';

    function PkgContent(element, options) {

        this.name = 'PkgContent';

        // Skip when we are already on paginated page
        // so users may navigate to previous pages
        if (window.location.search.search('\\?start=\\d+') != -1) {
            return;
        }

        this.options = (options || {});

        /** @type {boolean} Ajax request running */
        this.isRequestRunning = false;

        /** @type {Object} */
        this.$els = {};

        // Set common elements
        this.setCommonElements(jQuery(element));

        // No pagination for single page
        if (!this.$els.pagination.length) {
            return;
        }

        // Attach events
        this.attachListeners();
    }

    /**
     * Create new instance for jQuery.each
     *
     * @param {integer} index
     * @param {HTMLElement} element
     *
     * @return {PkgContent}
     *
     * @this {WgTemplate}
     */
    PkgContent.getInstance = function(index, element) {

        this.registerExtension(new PkgContent(element, this.options));
    };

    /**
     * Window scroll listener
     * Problem: event is fired after window height is adjusted
     *
     * @param {jQuery.Event} event
     */
    PkgContent.prototype.onWindowScroll = function(event) {

        // Bottom of screen, computed from document top
        var windowScrollBottom = this.$els.window.scrollTop() + this.$els.window.height();
        var lastGridBottom = this.$els.lastGrid.offset().top + this.$els.lastGrid.height();

        /*
        // Warning: When pagination is hidden, it's coords are whong
        var paginationTop = this.$els.pagination.offset().top;
        var lastGridBreakpoint = this.$els.lastGrid.height() / 2;

        // Loading only when reached pagination
        // if (windowScrollBottom < paginationTop) { return; }

        // Skip bottom side of scroll position is less than last grid
        // Problem: fires requests when scrolled below half of master grid height
        // if (windowScrollBottom < lastGridBottom - lastGridBreakpoint) { return; }
        /**/

        var halfWindowHeight = this.$els.window.height() / 2;

        // Only one master grid
        if (windowScrollBottom < lastGridBottom - halfWindowHeight) {
            return;
        }

        // Get current page
        var $current = this.$els.pagination.find('.uk-pagination > li[data-wg-pagination-page-current]');
        var $next = $current.next('li[data-wg-pagination-page]');

        if ($next.length) {
            this.requestPage($next.find('a').get(0).href);
        }
    };

    /**
     * Pagination link clicked (used for debugging)
     *
     * @param {jQuery.Event} event
     */
    PkgContent.prototype.onPaginationlinkClick = function(event) {

        event.preventDefault();

        this.requestPage(event.target.href);
    };

    /**
     * Set common elements
     *
     * @param {jQuery} $element
     *
     * @return {PkgContent}
     */
    PkgContent.prototype.setCommonElements = function($element) {

        this.$els.window = jQuery(window);

        /** @type {jQuery} Last grid element to append another one */
        this.$els.lastGrid = $element.find('[data-wg-pkg-content-grid]');

        /** @type {jQuery} Pagination element */
        this.$els.pagination = $element.find('[data-wg-pkg-content-pagination]');

        this.$els.loader = jQuery(
            '<div class="wg-pkg-content-loader uk-text-center uk-hidden">' +
                '<i class="uk-icon-refresh uk-icon-spin uk-icon-medium"></i>' +
            '</div>'
        );

        // Configure pagination
        this.$els.pagination.addClass('uk-hidden');
        this.$els.pagination.after(this.$els.loader);

        return this;
    };

    /**
     * Attach event listeners
     *
     * @return {PkgContent}
     */
    PkgContent.prototype.attachListeners = function() {

        this.$els.window.on('scroll', UIkit.Utils.throttle(jQuery.proxy(this.onWindowScroll, this), 200));
        this.$els.pagination.on('click', '.uk-pagination > li > a', jQuery.proxy(this.onPaginationlinkClick, this));

        return this;
    };

    /**
     * Request page and process it
     *
     * @param {string} linkUrl
     * @return {PkgContent}
     */
    PkgContent.prototype.requestPage = function(linkUrl) {

        // Skip if request is running
        if (this.isRequestRunning) {
            return this;
        }

        // Build request url
        linkUrl += (linkUrl.search('\\?') == -1 ? '?' : '&') + 'tmpl=raw';

        this.isRequestRunning = true;
        this.$els.loader.removeClass('uk-hidden');

        jQuery.ajax({
            method: 'GET',
            url: linkUrl,
            context: this
        })
            .done(function(data, textStatus, jqXHR) {
                var $document = jQuery(data);
                var $element = $document.find('[data-wg-pkg-content]');

                var $grid = $element.find('[data-wg-pkg-content-grid]');
                var $pagination = $element.find('[data-wg-pkg-content-pagination]');

                // Append after last grid.
                // Note: injecting items into current grid doesn't work properly (no margins and matches)
                if ($grid.length) {
                    // Append after (new UIkit components will auto-init)
                    // this.$els.lastGrid.after($grid);
                    // this.$els.lastGrid = $grid;

                    // Inject inside (Need to reinitialize some components)
                    this.$els.lastGrid.append($grid.html());

                    // Fix margins below panels
                    UIkit.Utils.checkDisplay(this.$els.lastGrid);

                    // Reset block match height (janky)
                    UIkit.gridMatchHeight(this.$els.lastGrid).init();
                }

                // ReplaceWith but keep events
                if ($pagination.length) {
                    this.$els.pagination.html($pagination.html());
                }

            })
            .always(function(dataOrJqXhr, textStatus, jqXhrOrErrorThrown) {
                this.isRequestRunning = false;
                this.$els.loader.addClass('uk-hidden');
            })
        ;

        return this;
    };

    return PkgContent;

}(jQuery));
